import React, {useRef} from 'react';
import Draggable from '../Draggable/Draggable';
import Picture from './Picture.js'
import Shape from './Shape.js'
import objeler from '../../components/objeler';
import {Editor as Word} from '../../react-draft-wysiwyg/dist/react-draft-wysiwyg'
import '../../react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import Barcode from './Barcode';
import Slider from './Slider';
import Table from './Table';

type Props = {
    context?: {
        properties: {
            alignment?: string,
            Text?: string,
            Font?: string,
            FontWeiht?: string,
            FontSize?: string,
            Bold?: boolean,
            Italic?: boolean,
            Bound?: boolean,
            Continuous?: boolean,
            Align?: string,
            CharSpacing?: Boolean,
            DataType?: string,
            Format?: string,
            SourceFormat?: string,
            DataSource?: string,
            Condition?: string,
            Calculation?: string,
            CalculationKey?: string,
            ConditionKeys?: string,
            Resource?: string,
            MLine?: boolean,
            MLineWidth?: string,
            Jpg: string,
            JpgPath: string,
            JpgFileName: string,
            CertFileName: string,
            CertPath: string,
            CertFileName: string,
            ContentState: Object,
            BorderColor: string,
            Fill: boolean,
            FillColor: string,
            BorderWidth: string,
            BorderStyle: string,
            Direction: string,
            QREncoding: integer,
            QRVersion: integer,
            QRLevel: integer,
            BarcodeType: String,
            Thickness: integer,
            QRUnicode: integer,
            Zindex: integer,
            colors?: {
                color: string | null,
                backgroundColor: string | null
            }
        },
        content: string,
        ObjName: string
    },
    id: string,
    handleDoubleClick: Function
};
const getAlign = (e, width, id, content, fontFamily, fontSize, fontWeight, fontStyle) => {
    if (e == '1')
        return 'right'
    if (e == '2')
        return 'center'
}
const lineSpac = (e) => {
}
const getLetter = (cont_width, id, text, align, fontFamily, fontSize, fontWeight, fontStyle) => {
    if (align === '3') {
        var nb_char = text.length;
        var spacing = cont_width / nb_char;
        var ltr_spacing = spacing - char_width + (spacing - char_width) / nb_char;
        const st = 'display:none;font-family:' + fontFamily + ';font-size:' + fontSize + 'px;font-weight: ' + (fontWeight ? 'bold' : 'normal') + '; font-style: ' + (fontStyle ? 'italic' : 'normal') + ';'
        var calc = '<span style="' + st + '">' + text + '</span>';
        $('body').append(calc);
        var char_width = $('body').find('span:last').width() / nb_char;
        $('body').find('span:last').remove();
        var ltr_spacing = spacing - char_width + (spacing - char_width) / nb_char;
        return ltr_spacing + 'px';
    } else {
        return null;
    }
};
const computedStyle = (properties, id, content, type) => ({
        color: properties && properties.colors ? properties.colors.color : null,
        backgroundColor: properties && properties.colors ? properties.colors.backgroundColor : null,
        fontFamily: properties.Font,
        whiteSpace: type == 'TextBox' ? 'nowrap' : null,
        fontSize: properties.FontSize + "px",
        fontWeight: properties.Bold ? 'bold' : 'normal',
        fontStyle: properties.Italic ? 'italic' : 'normal',
        textAlign: getAlign(properties.Align, properties.size.width, id, content, properties.Font, properties.FontSize, properties.Bold, properties.Italic),
        letterSpacing: getLetter(properties.size.width, id, content, properties.Align, properties.Font, properties.FontSize, properties.Bold, properties.Italic),
        zIndex: properties.Zindex
    }
);
const handleParentFun = (e) => {
    alert(e.Font);
}
const onWordStateChange = (e) => {
}
const Default = ({id, context, OpenProperties, onMouseDown, RemoveIconScale, GridSize}: Props) => {
    let wordRef = useRef();
    const {content, Jpg, JpgPath, properties, type, JpgBlob} = context;
    const stl = {
        background: `url(${properties.JpgBlob})`,
        backgroundSize: '30% 30%',
        backgroundRepeat: 'no-repeat',
        width: '100%',
        height: '100%',
        maxwidth: '100%',
        maxheight: '100%',
        backgroundposition: 'center'
    };
    const blobFile = properties.JpgBlob;
    const onPictureLoad = (e) => {
        context.properties.JpgOriginalWidth = e.JpgOriginalWidth;
        context.properties.JpgOriginalHeight = e.JpgOriginalHeight;
        context.properties.JpgOriginalAspectRatio = e.JpgOriginalAspectRatio;
    }
    return (
        <Draggable id={id} 
                   type={type}
                   properties={properties} 
                   onMouseDown={(e) => {
            objeler.closeMenu();
            onMouseDown(e)
        }}
                   style={computedStyle(properties, id, content, type)}
                   RemoveIconScale={RemoveIconScale}
                   GridSize={GridSize}
                   OpenProperties={e => {
                       OpenProperties(e);
                   }}
        >
            {
                (() => {
                    switch (type) {
                        case 'TextBox':
                            return content;
                            break;
                        case 'Slider':
                            return <Slider/>;
                            break;
                        case 'Barcode':
                            return <Barcode BarcodeType={properties.BarcodeType} Color={properties.colors.color}
                                            pictureOnLoad={e => onPictureLoad(e)}
                            />;
                            break;
                        case 'Word':
                            if (properties.ContentState == "")
                                return "Word";
                            else return (
                                <Word
                                    ref={wordRef}
                                    toolbarClassName="toolbadrClassName"
                                    toolbarHidden="true"
                                    readOnly="true"
                                    wrapperClassName="wrapperClassName"
                                    editorClassName="editorClassName"
                                    contentState={properties.ContentState}
                                />
                            )
                        case 'Picture':
                            if (properties.JpgBlob == "" || properties.JpgPath == "http://localhost:8000/publicundefined")
                                return "Picture";
                            else
                                return <Picture id={id} pictureOnLoad={e => onPictureLoad(e)} file={properties.JpgBlob}
                                                element={properties}></Picture>;
                        case 'Signature':
                            if ((properties.JpgFileName == "" || properties.JpgPath == "http://localhost:8000/publicundefined") && content == "")
                                return "Signature";
                            else
                                return <Picture pictureOnLoad={e => onPictureLoad(e)} file={properties.JpgBlob}
                                                content={content}></Picture>;
                        case 'Rectangle':
                            return <Shape type={type} BorderColor={properties.BorderColor}
                                          BorderStyle={properties.BorderStyle} BorderWidth={properties.BorderWidth}
                                          FillColor={properties.FillColor} Fill={properties.Fill}></Shape>;
                        case 'Lines':
                            return <Shape type={type} BorderColor={properties.BorderColor}
                                          Direction={properties.Direction} BorderStyle={properties.BorderStyle}
                                          BorderWidth={properties.BorderWidth}></Shape>;
                        case 'Ellipse':
                            return <Shape type={type} BorderColor={properties.BorderColor}
                                          BorderStyle={properties.BorderStyle} BorderWidth={properties.BorderWidth}
                                          FillColor={properties.FillColor} Fill={properties.Fill}></Shape>;
                            break;
                        case 'Table':
                            return <Table
                                TableData={properties.TableData}
                                BorderColor={properties.BorderColor}
                                BorderWidth={properties.BorderWidth}
                                BorderStyle={properties.BorderStyle}
                                Fill={properties.Fill}
                                FillColor={properties.FillColor}
                                HasHeader={properties.HasHeader}
                                HeaderHeight={properties.HeaderHeight}
                                RowHeight={properties.RowHeight}
                                ZebraStripe={properties.ZebraStripe}
                                AlternateColor={properties.AlternateColor}
                            />;
                            break;
                        default:
                            return null;
                            break;
                    }
                }).call(this)
            }
        </Draggable>
    );
};
Default.defaultProps = {
    context: {
        properties: {
            alignment: 'left',
            Text: '',
            Font: 'Calibri',
            FontWeiht: 'Normal',
            FontSize: '12',
            Bold: false,
            Italic: false,
            Jpg: '',
            JpgPath: '',
            colors: {
                color: '#000',
                backgroundColor: '#fff',
                Text2: 'ddd'
            }
        }
    }
};
export default Default;
